import React, { useEffect, useState } from 'react';
import { formatDistance } from "date-fns";
import { Link } from 'react-router-dom';
import Page from '../../../components/Page';
import Breadcrumb from '../../../components/Breadcrumb';
import client from '../../../lib/feathers';

export default function PendingUserInvitations() {
  const [results, setResults] = useState();

  const loadData = async () => {
    const service = client.service('/admin/listing-user-invitation');
    const data = await service.find({
      query: {
        $sort: { createdAt: -1 }
      }
    });
    console.log('All invitations data:', data);

    // Filter for pending invitations (status === null)
    const pendingInvitations = {
      ...data,
      data: data.data.filter(invitation => invitation.status === null)
    };

    console.log('Pending invitations:', pendingInvitations);
    console.log('Number of pending:', pendingInvitations.data.length);
    setResults(pendingInvitations);
  }

  useEffect(() => {
    loadData();
  }, []);

  return (
    <Page title="Reports">
      <div className="pb-5 border-b border-gray-200 sm:flex sm:items-center sm:justify-between">
        <nav className="flex" aria-label="Breadcrumb">
          <Breadcrumb elements={[
            { name: 'Reports', href: `/admin/reports` },
            { name: 'Pending User Invitations' }
          ]} />
        </nav>
      </div>

      <div className="py-5 border-b border-gray-200 sm:flex sm:items-center sm:justify-between">
        {!results && `Loading...`}
        {results && (
          <div className="flex flex-col w-full">
            <h1 className="text-2xl pb-5">Pending User Invitations</h1>
            {results.data.length === 0 ? (
              <div className="text-center py-12">
                <p className="text-gray-500">No pending invitations</p>
              </div>
            ) : (
              <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                  <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                    <table className="min-w-full divide-y divide-gray-200">
                      <thead className="bg-gray-50">
                        <tr>
                          <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            <b>User</b>
                          </th>
                          <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            <b>Listing</b>
                          </th>
                          <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            <b>Personal Email</b>
                          </th>
                          <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            <b>Business Email</b>
                          </th>
                          <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            <b>Requested</b>
                          </th>
                          <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            <b>Actions</b>
                          </th>
                        </tr>
                      </thead>
                      <tbody className="bg-white divide-y divide-gray-200">
                        {results.data.map((invitation) => (
                          <tr className="hover:bg-gray-100 cursor-pointer" key={invitation.id}>
                            <td className="px-6 py-4 whitespace-nowrap">
                              <div className="flex items-center">
                                <div className="ml-4">
                                  <div className="text-sm font-medium text-gray-900">
                                    {invitation.user.firstName} {invitation.user.lastName}
                                  </div>
                                </div>
                              </div>
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap">
                              <div className="text-sm text-gray-900">{invitation.listing.name}</div>
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap">
                              <div className="text-sm text-gray-500">{invitation.user.email}</div>
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap">
                              <div className="text-sm text-gray-500">
                                {invitation.email || <span className="text-gray-400">N/A</span>}
                              </div>
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap">
                              <div className="text-sm text-gray-500">
                                {formatDistance(new Date(invitation.createdAt), new Date(), { addSuffix: true })}
                              </div>
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                              <Link
                                to={`/admin/listings/${invitation.listing.id}/users`}
                                className="text-red-600 hover:text-red-900"
                              >
                                View/Approve
                              </Link>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </Page>
  );
}
